import React from 'react';
import PropTypes from 'prop-types';
import {Glyphicon} from 'react-bootstrap';

import styled from 'styled-components';
import '../SetupWizard.scss';
import {WizardFlag} from '../../../constants/SetupWizardEnum';

const FlagImage = styled(Glyphicon).attrs(({glyph}) => ({
  glyph,
  bsClass: glyph,
}))`
  color: ${(props) => props.color};
  font-size: 15vh;
  border: 1px solid white;
  border-radius: 100%;
  background-color: white;
`;

const WizardFlagUIContainer = styled.div.attrs({
  className: 'ui-flag',
})`
  position: relative;
  top: 35%;
  bottom: 0;
  left: 0;
`;

function WizardFlagUI({flag, onGetFlagMsg, hide}) {
  const getFlagImage = () => {
    switch (flag) {
      case WizardFlag.SUCCESS:
        return <FlagImage glyph="icon-checkbox-default" color="#4CAF50" />;
      case WizardFlag.ERROR:
        return <FlagImage glyph="icon-error" color="#FF5252" />;
      default:
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
  };

  return (
    <div className={`wizard-flag-container ${hide && 'hidden'}`}>
      <WizardFlagUIContainer>
        {getFlagImage()}
        <p style={{fontSize: '1.3vw', marginTop: '1vw'}}>{onGetFlagMsg(flag, false)}</p>
      </WizardFlagUIContainer>
    </div>
  );
}

WizardFlagUI.propTypes = {
  flag: PropTypes.string.isRequired,
  onGetFlagMsg: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
};

export default WizardFlagUI;
